import React, { useEffect, useState } from "react";
import ChartBar from "../Bar";
import { EChartsOption } from "echarts";
import LcIconLink from "../../Generic/LcIconLink";
import SideModal from "../../Layout/SideModal/SideModal";
import { MenuState } from "../../../store/reducers/menuReducer";
import { RootState } from "../../../store";
import { useSelector } from "react-redux";
import "./index.css";
import LcDropDown from "../../Generic/LcDropDown";
import LcIcon from '../../Generic/LcIcon';

interface Props {
    // title: string;
    chartData?: any;
    detailed?: boolean;
    onClickBar?: Function;
    options?: any;
    onChange: (value: any) => void;
    value?: any;
    tooltipCanceled?: string;
}

const SingleBarDetails: React.FC<Props> = (props) => {
    const [topTenValueList, setTopTenValueList] = React.useState<any[]>([]);
    const [topTenTitleList, setTopTenTitleList] = React.useState<any[]>([]);
    const [focus, setFocus] = useState<boolean>(false);
    const menu = useSelector<RootState, MenuState>(state => state.menu);

    React.useEffect(() => {
        if (props.chartData.length > 1) {
            var _chartData = (props.detailed || focus) ? props.chartData.slice(0, 10) : props.chartData.slice(0, 3);
            let _topTenListValue: any[] = [];
            let _topTenListTitle: any[] = [];

            _chartData
                .sort((a, b) => { return a.closed > b.closed ? 1 : -1 })
                .forEach((item: any) => {
                    _topTenListValue.push(item.count);
                    _topTenListTitle.push(item.descricao);
                })

            setTopTenValueList(_topTenListValue);
            setTopTenTitleList(_topTenListTitle);
        }
    }, [props.chartData, props.detailed, focus])

    const onClickBar = (params: any) => {
        var option = props.options.find(x => x.value === props.value);
        console.log(option);
        console.log(props.options);
        console.log(params);
        params = {
            ...params,
            local: "Top10",
            type: option.type,
            descricao: params.name
        };

        props.onClickBar && props.onClickBar(params);
    }

    const yAxisLabelFormatter = (value: any) => {
        const maxLength = 20;

        if (value.length > maxLength) {
            return value.slice(0, 20) + "...";
        }

        return value;
    };

    const options: EChartsOption = {
        tooltip: {
            show: props.detailed || focus,
            trigger: "axis",
            axisPointer: {
                type: "shadow"
            },
        },
        legend: {},
        grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            top: "2%",
            containLabel: true
        },
        xAxis: {
            type: "value",
            boundaryGap: [0, 0.01],
            axisLabel: {
                show: props.detailed,
            },
        },
        yAxis: {
            type: "category",
            data: topTenTitleList,
            axisLabel: {
                formatter: yAxisLabelFormatter,
            },
            tooltip: {
                show: true,
            },
        },
        series: [
            {
                data: topTenValueList,
                type: "bar",
                label: {
                    // show: props.detailed || focus,
                    show: true,
                    fontSize: "10px",
                    fontWeight: "bold",
                },
                barWidth: 25,
            },
        ],
    }

    const handleTitleFocus = () => {
        let title = props.options.find((item: any) => item.value === props.value)?.label;

        if ((props.detailed || focus) && title.includes("3")) {
            title = title.replace("3", "10");
        }

        return title;
    }

    const handleLabel = (item: any) => {
        let label = item.label;

        if ((props.detailed || focus) && label.includes("3")) {
            label = label.replace("3", "10");
        }

        return label;
    }

    const Dropdown = () => {
        return (
            <div
                className={"dropdownalt"}
                style={{
                    paddingLeft: "7px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    height: "40px",
                    width: "290px",
                    padding: '20px 10px',
                    backgroundColor: '#fff',
                    marginBottom: (focus) ? "0px" : "5px"
                }}>
                <LcDropDown
                    width={"220px"}
                    style={{ width: "100%" }}
                    element={
                        <span className={"select-period"}
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                fontSize: '16px',
                                fontWeight: '400'
                            }}>
                            {/* &nbsp;{props.options.find((item: any) => item.value === props.value)?.label} */}
                            &nbsp;{handleTitleFocus()}
                            <i className={"ppi ppi-chevron-down-alt"} />
                        </span>
                    }
                >
                    {
                        props.options.map((item: any, index: number) => {
                            return (
                                <span
                                    key={index}
                                    className="item"
                                    onClick={() => props.onChange(item)}
                                    style={{ fontWeight: (item.value === props.value) ? "bold" : "normal" }}
                                >
                                    {handleLabel(item)}
                                </span>
                            )
                        })
                    }
                </LcDropDown>
            </div>
        )
    }

    return (
        <>
            {
                !focus &&
                <div
                    className={`chartbox ${!props.detailed && "wDash32p"} boxShadowLightBlack`}
                    style={{
                        height: "100%",
                        width: "49%",
                        marginRight: "0px"
                    }}>
                    <div
                        className={"row start"}
                        style={{
                            paddingLeft: "16px",
                            paddingTop: "6px",
                            color: "#8B90A3",
                            fontSize: "16px",
                            display: "flex",
                            justifyContent: "space-between"
                        }}>
                        <Dropdown />
                        {
                            props.tooltipCanceled &&
                            <LcIcon icon={"ppi ppi-information-circle"} tooltipPosition={"right"} size={"small"} color={"#000"} tooltip={props.tooltipCanceled} />
                        }
                        <LcIconLink
                            icon={"ppi ppi-expand"}
                            tooltip={"Ampliar"}
                            onClick={() => setFocus(true)}
                        />
                    </div>

                    <ChartBar options={options} onclickBar={onClickBar} />
                </div>
            }

            <SideModal
                header={
                    <div className={`row start`}>
                        <span style={{ marginRight: "50px" }}>{`${handleTitleFocus()} - Foco`}</span>
                        <Dropdown />
                    </div>
                }
                visible={focus}
                onClose={() => setFocus(false)}
                width={(!menu.toggle) ? "calc(100% - 260px)" : "calc(100% - 5rem)"}
            >
                {
                    <div className={`row column`} style={{ height: "100%" }}>
                        <div style={{ width: "100%", height: "100%" }}>
                            <ChartBar
                                options={options}
                                onclickBar={onClickBar}
                                height={"100%"}
                            />
                        </div>
                    </div>
                }
            </SideModal>
        </>
    );
};

export default SingleBarDetails;